import React, { PureComponent } from 'react'

export class VerbasManuais extends PureComponent {
  render() {
    return (
      <div>VerbasManuais</div>
    )
  }
}

export default VerbasManuais